import { render, staticRenderFns } from "./AdminServiceEdit.vue?vue&type=template&id=4f47786a"
import script from "./AdminServiceEdit.vue?vue&type=script&lang=js"
export * from "./AdminServiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports